import { Injectable } from '@angular/core';

@Injectable()
export class NotificationReportCreation {
    public creation: any[] = [
        { value: 0, name: 'TODOS' },
        { value: 1, name: 'Este Mes' },
        { value: 2, name: 'Esta Semana' },
        { value: 3, name: 'Hoy' },
        { value: 4, name: 'Ayer' },
        { value: 5, name: 'Semana Pasada' },
        { value: 6, name: 'Mes Pasado' },
        { value: 7, name: 'Rango' }
    ];

    constructor() { }
}

@Injectable()
export class NotificationReportStatus {
    public status: any[] = [
        { value: 'SCHEDULED', label: 'Programado' },
        { value: 'SENT', label: 'Enviado' },
        { value: 'DELIVERED', label: 'Entregado' },
        { value: 'OPENED', label: 'Abierto' },
        { value: 'VOIDED', label: 'Anulado' },
        { value: 'REJECTED', label: 'Rechazado' },
        { value: 'PROCESSED', label: 'Procesado' },
        { value: 'RECEIVED', label: 'Recibido' },
        { value: 'CLICKED', label: 'Clic' },
        { value: 'DEFERRED', label: 'Postergado' },
        { value: 'BOUNCED', label: 'Rebotado' },
        { value: 'DROPPED', label: 'Descartado' },
        { value: 'SPAM', label: 'SPAM' },
        { value: 'UNDELIVERED', label: 'No entregado' }
    ];

    constructor() { }
}

@Injectable()
export class NotificationReportChannel {
    public channel: any[] = [
        { value: 0, name: 'TODOS' },
        { value: 1, name: 'WEBHOOK' },
        { value: 2, name: 'EMAIL' },
        { value: 3, name: 'SMS' },
        { value: 4, name: 'Push' },
        { value: 5, name: 'WHATSAPP' }
    ];

    constructor() { }
}